import { DataError, LoadingIndicator, Table } from "@digital-services/ui";

// import { getRandomApiSecrets } from "../../mocks/api-secrets.gen";
import { useGetApiSecrets } from "../../services/use-get-api-secrets";
import { CreateApiSecretButton } from "../CreateApiSecretButton";
import { NoApiSecretsConfigured } from "../NoApiSecretsConfigured";
import { ApiSecretDataRow } from "./ApiSecretDataRow";
import { ApiSecretsHeaderRow } from "./ApiSecretsHeaderRow";

export const ApiSecretsTable = () => {
  const { apiSecrets, isLoading, error } = useGetApiSecrets();

  // const apiSecrets = getRandomApiSecrets(0);
  // const apiSecrets = getRandomApiSecrets(1);
  // const apiSecrets = getRandomApiSecrets(2);

  if (isLoading) {
    return (
      <div className="flex w-full items-center text-base">
        <LoadingIndicator label={"Loading API secrets"} />
      </div>
    );
  }

  if (error) {
    return (
      <DataError
        title={"Error loading API secrets"}
        message=""
        className="text-left! text-red-600"
      />
    );
  }

  if (!apiSecrets?.length) {
    return <NoApiSecretsConfigured />;
  }

  return (
    <>
      <div className="mb-3 flex items-center justify-end gap-3">
        <div className="grow"></div>
        {false ? (
          <CreateApiSecretButton disabled={apiSecrets!.length >= 2} />
        ) : null}
      </div>

      <div data-testid="api-secrets-table">
        <Table className="w-full" rowHoverHighlight>
          <thead>
            <ApiSecretsHeaderRow />
          </thead>
          <tbody>
            {apiSecrets.map(item => {
              const componentKey = `row-key-${item.secretValue.slice(0, 10)}`;
              return <ApiSecretDataRow data={item} key={componentKey} />;
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};
